import React, { useState, useMemo } from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Card,
  Row,
  Col,
  Button
} from '@lockerpm/design';

import {
  EditOutlined
} from "@ant-design/icons";

import { gray } from '@ant-design/colors';

import FormData from "./FormData";
import itemsComponents from "../../../../../components/items";

import {
  timeFromNow,
} from '../../../../../utils/common'

const General = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation()
  const {
    className = '',
    workspace = {}
  } = props;
  const [formVisible, setFormVisible] = useState(false);

  const dataFields = useMemo(() => {
    if (workspace) {
      return [
        {
          name: t('information.workspace_name'),
          lg: 8,
          value: <TextCopy
            value={workspace.name}
            color={gray[2]}
          />
        },
        {
          name: t('common.created_time'),
          lg: 8,
          value: <TextCopy
            value={timeFromNow(workspace.creation_date)}
            color={gray[2]}
          />
        },
        {
          name: t('common.updated_time'),
          lg: 8,
          value: <TextCopy
            value={timeFromNow(workspace.updated_date)}
            color={gray[2]}
          />
        },
        {
          name: t('common.description'),
          lg: 24,
          value: <TextCopy
            value={workspace.description}
          />
        },
      ]
    }
    return []
  }, [workspace])

  return (
    <div className={className}>
      <Card
        title={<div className="flex items-center justify-between">
          <p className="font-bold">{t('information.general_information')}</p>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => setFormVisible(true)}
          >
            {t('button.edit')}
          </Button>
        </div>}
      >
        <Row gutter={[12, 24]}>
          {
            dataFields.map((f, i) => <Col
              key={i}
              lg={f.lg}
              md={8}
              sm={8}
              xs={24}
            >
            <p className="font-bold text-l mb-1">
              {f.name}
            </p>
            {f.value}
          </Col>)
          }
        </Row>
      </Card>
      <FormData
        workspace={workspace}
        visible={formVisible}
        onClose={() => setFormVisible(false)}
        onReload={() => {}}
      />
    </div>
  );
}

export default General;
